export default __webpack_public_path__ + "files/2bf8ce186e01fc2cda497be66e4225ae.mp3";